import React, { useEffect, useState } from "react";
import { CircularProgress, Tooltip } from "@material-ui/core";
import { C, FIELD_HEIGHT } from "../RouteConfiguration/util";

import { FixedSizeList } from "react-window";
import { Popper } from "@mui/material";

// Add this component outside PhotoMode
export const LISTBOX_ITEM_HEIGHT = 40;
const LISTBOX_MAX_VISIBLE = 8;

export const VirtualListbox = React.forwardRef(
  function VirtualListbox(props, ref) {
    const { children, ...other } = props;
    const itemData = React.Children.toArray(children);
    const itemCount = itemData.length;
    const height =
      Math.min(itemCount, LISTBOX_MAX_VISIBLE) * LISTBOX_ITEM_HEIGHT;

    return (
      <div ref={ref} {...other}>
        <FixedSizeList
          height={height}
          width="100%"
          itemSize={LISTBOX_ITEM_HEIGHT}
          itemCount={itemCount}
          overscanCount={5}
        >
          {({ index, style }) => <div style={style}>{itemData[index]}</div>}
        </FixedSizeList>
      </div>
    );
  },
);

export const ALERT_PAIRS = [
  [
    { key: "DEVICE_LOCK", label: "Lock" },
    { key: "DEVICE_UNLOCK", label: "Unlock" },
  ],
  [
    { key: "TEMPERING_ALERT", label: "Tampering" },
    { key: "ROUTE_DEVIATION_ALERT", label: "Route Deviation" },
  ],
  [
    { key: "DESTINATION_ENTRY", label: "Destination Entry" },
    { key: "SOURCE_EXIT", label: "Source Exit" },


  ],
  [
    { key: "MIDPOINT_ENTRY", label: "Midpoint Entry" },
    { key: "MIDPOINT_EXIT", label: "Midpoint Exit" },

    // { key: "AUTHORIZED_STOPPAGE", label: "Authorized Stoppage" },
  ],
  [

    { key: "TRIP_START", label: "Trip Start" },
    { key: "TRIP_END", label: "Trip End" },
  ],
  [

    { key: "UN_AUTH_STOPPAGE_ALERT", label: "Unauthorized Stoppage" },
  ],
];

export const DEFAULT_ALERTS = ALERT_PAIRS.flat().reduce((acc, item) => {
  if (item) acc[item.key] = true;
  return acc;
}, {});

export const PHOTO_MODE_ALERT_PAIRS = [
  [
    { key: "DEVICE_LOCK", label: "Lock" },
    { key: "DEVICE_UNLOCK", label: "Unlock" },
  ],
  [
    { key: "TEMPERING_ALERT", label: "Tampering" },
    { key: "TRIP_START", label: "Trip Start" },
  ],
  [
    { key: "TRIP_END", label: "Trip End" },
    { key: "UN_AUTH_STOPPAGE_ALERT", label: "Unauthorized Stoppage" },
  ],
];

export const PHOTO_MODE_DEFAULT_ALERTS = PHOTO_MODE_ALERT_PAIRS.flat().reduce(
  (acc, item) => {
    if (item) acc[item.key] = true;
    return acc;
  },
  {},
);

export const DESTINATION_MODE_ALERT_PAIRS = [
  [
    { key: "DEVICE_LOCK", label: "Lock" },
    { key: "DEVICE_UNLOCK", label: "Unlock" },
  ],
  [
    { key: "TEMPERING_ALERT", label: "Tampering" },
    { key: "TRIP_START", label: "Trip Start" },
  ],
  [
    { key: "TRIP_END", label: "Trip End" },
    { key: "DESTINATION_ENTRY", label: "Destination Entry" },
  ],
  [{ key: "UN_AUTH_STOPPAGE_ALERT", label: "Unauthorized Stoppage" }, null],
];

export const DESTINATION_MODE_ALERT_PAIRS_DEFAULT_ALERTS =
  DESTINATION_MODE_ALERT_PAIRS.flat().reduce((acc, item) => {
    if (item) acc[item.key] = true;
    return acc;
  }, {});

export const MODES = [
  // { id: "photo", label: "Photo Verified" },
  { id: "destination", label: "Destination Mode" },
  { id: "geofence", label: "Geofence Route" },
];

export const GEOFENCE_STEPS = [
  "Select Route",
  "Trip Details",
  "Review & Confirm",
];

export const STATUS_CONFIG = {
  ALL: {
    label: "All",
    dot: "#6b7280",
    chip: "#f3f4f6",
    chipText: "#374151",
    border: "#d1d5db",
  },
  RUNNING: {
    label: "Running",
    dot: "#22c55e",
    chip: "#dcfce7",
    chipText: "#15803d",
    border: "#86efac",
  },
  STOP: {
    label: "Stop",
    dot: "#ef4444",
    chip: "#fee2e2",
    chipText: "#b91c1c",
    border: "#fca5a5",
  },
  IDLE: {
    label: "Idle",
    dot: "#f97316",
    chip: "#ffedd5",
    chipText: "#c2410c",
    border: "#fdba74",
  },
  OFFLINE: {
    label: "Offline",
    dot: "#38bdf8",
    chip: "#e0f2fe",
    chipText: "#0369a1",
    border: "#7dd3fc",
  },
  NO_NETWORK: {
    label: "No Network",
    dot: "#a855f7",
    chip: "#f3e8ff",
    chipText: "#7e22ce",
    border: "#d8b4fe",
  },
};
export const SectionLabel = ({ children }) => (
  <div
    style={{
      fontSize: 14,
      fontWeight: 700,
      letterSpacing: "0.7px",
      textTransform: "uppercase",
      color: C.primary,
      marginBottom: 8,
    }}
  >
    {children}
  </div>
);

export const FieldLabel = ({ children, required }) => (
  <div
    style={{ fontSize: 14, fontWeight: 600, color: C.primary, marginBottom: 4 }}
  >
    {children}
    {required && <span style={{ color: C.error }}> *</span>}
  </div>
);

export const FieldWrap = React.forwardRef(({ children, mb = 14 }, ref) => (
  <div ref={ref} style={{ marginBottom: mb }}>{children}</div>
));

export const HR = () => (
  <hr
    style={{
      border: "none",
      borderTop: `1px solid ${C.border}`,
      margin: "12px 0",
    }}
  />
);

export const PrimaryBtn = ({
  onClick,
  disabled,
  loading,
  children,
  style = {},
}) => (
  <button
    onClick={onClick}
    disabled={disabled || loading}
    style={{
      flex: 1,
      height: FIELD_HEIGHT,
      background: disabled || loading ? "#e8eef8" : C.primary,
      color: disabled || loading ? C.textFaint : "#fff",
      border: "none",
      borderRadius: 10,
      fontSize: 13,
      fontWeight: 600,
      cursor: disabled || loading ? "not-allowed" : "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      ...style,
    }}
  >
    {loading && <CircularProgress size={14} style={{ color: C.primary }} />}
    {children}
  </button>
);

export const SecondaryBtn = ({
  onClick,
  disabled,
  loading,
  children,
  style = {},
}) => (
  <button
    onClick={onClick}
    disabled={disabled || loading}
    style={{
      flex: 1,
      height: FIELD_HEIGHT,
      background: disabled || loading ? "#e8eef8" : "green",
      color: disabled || loading ? C.textFaint : "#fff",
      border: "none",
      borderRadius: 10,
      fontSize: 13,
      fontWeight: 600,
      cursor: disabled || loading ? "not-allowed" : "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      ...style,
    }}
  >
    {loading && <CircularProgress size={14} style={{ color: C.primary }} />}
    {children}
  </button>
);

export const OutlineBtn = ({ onClick, children, style = {} }) => (
  <button
    onClick={onClick}
    style={{
      height: FIELD_HEIGHT,
      padding: "0 16px",
      background: "transparent",
      border: `1.5px solid ${C.border}`,
      borderRadius: 10,
      fontSize: 13,
      fontWeight: 500,
      color: C.textMuted,
      cursor: "pointer",
      ...style,
    }}
  >
    {children}
  </button>
);

export const OffsetPopper = (props) => (
  <Popper
    {...props}
    disablePortal={false}
    style={{ ...props.style, zIndex: 1400 }}
    modifiers={{
      offset: { enabled: true, offset: "0, -80" },
      flip: { enabled: false },
      preventOverflow: { enabled: true, boundariesElement: "window" },
    }}
    placement="bottom-start"
  />
);

export const PhotoPaperComponent = ({ children, ...paperProps }) => (
  <div
    {...paperProps}
    style={{
      background: "#fff",
      borderRadius: 10,
      boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
      border: "1px solid #e8eef8",
      overflow: "hidden",
    }}
  >
    {children}
  </div>
);
export function FilterField({ label, children }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
      {children}
    </div>
  );
}

function geocodeLatLng(lat, lng, callback) {
  fetch(
    `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`,
    { headers: { "Accept-Language": "en" } },
  )
    .then((res) => res.json())
    .then((data) => {
      callback(data?.display_name || `${lat.toFixed(5)}, ${lng.toFixed(5)}`);
    })
    .catch(() => {
      callback(`${lat.toFixed(5)}, ${lng.toFixed(5)}`);
    });
}

export function GeocodedAddress({ lat, lng, fallback, isTripPanel = false }) {
  const [address, setAddress] = useState(null);
  useEffect(() => {
    if (lat == null || lng == null) return;
    if (fallback && !/^-?\d+\.\d+,/.test(fallback)) {
      setAddress(fallback);
      return;
    }
    geocodeLatLng(lat, lng, (addr) => setAddress(addr));
  }, [lat, lng, fallback]);

  if (!address) {
    return (
      <span
        style={{
          color: isTripPanel ? "#334155" : "#161617",
          fontStyle: !isTripPanel && "italic",
          fontSize: isTripPanel ? 11 : 13,
        }}
      >
        {lat != null ? `${lat.toFixed(4)}, ${lng.toFixed(4)}` : "—"}
      </span>
    );
  }

  const isLong = address.length > 30;
  const displayText = isLong ? `${address.slice(0, 30).trim()}…` : address;

  const content = (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        fontSize: isTripPanel ? 11 : 13,
        color: isTripPanel ? "#334155" : "#161617",
        lineHeight: 1.4,
        cursor: isLong ? "pointer" : "default",
      }}
    >
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {displayText}
      </span>
    </span>
  );

  if (!isLong) return content;

  return (
    <Tooltip
      title={address}
      arrow
      placement="top"
      componentsProps={{
        tooltip: {
          style: {
            background: "#082D6B",
            fontSize: 13,
            fontFamily: "'Syne',sans-serif",
            padding: "8px 12px",
            borderRadius: 8,
            maxWidth: 280,
            lineHeight: 1.5,
            boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
          },
        },
        arrow: { style: { color: "#082D6B" } },
      }}
    >
      {content}
    </Tooltip>
  );
}
